import { LinkPillReadOnly, type PillLink } from '@/components/EditorPill'
import { NewspaperIcon } from '@ttab/elephant-ui/icons'
import type { JSX } from 'react'
import { useTranslation } from 'react-i18next'

/**
 * Read-only content source for documents with no Yjs document to read from,
 * such as the frozen `usable`/`withheld`/`used` snapshot rendered by
 * PlainEditor. Sourced from the fetched document snapshot instead of
 * `useYValue`.
 */
export const EditorContentSourceReadOnly = ({ sources }: {
  sources: PillLink[] | undefined
}): JSX.Element => {
  const { t } = useTranslation('metaSheet')

  return (
    <LinkPillReadOnly
      field='content-source'
      links={sources}
      Icon={NewspaperIcon}
      emptyLabel={t('misc.noSource')}
    />
  )
}
